import React from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { ReactComponent as SmartBenchmarkIcon } from '../../../assets/images/smart-benchmark.svg';

const BenchmarkHeader = ({
  canExport = false,
  isExporting = false,
  onExport,
  reportingPeriod = '',
  showExportButton = true,
}) => {
  const { t } = useTranslation();

  return (
    <div className="d-flex justify-content-between align-items-center mb-4" >
      <div className="d-flex align-items-center">
        <div
          className="mr-3 rounded-6 d-flex align-items-center justify-content-center"
          style={{
            width: 40,
            height: 40,
            backgroundColor: '#E6F9EF',
            color: '#16A34A',
            fontWeight: 700,
          }}
        >
          <SmartBenchmarkIcon />
        </div>
        <div>
          <div className="font-weight-bold">{t('CarbonView')}</div>
          <div className="text-muted small">{t('Smart Benchmarking Module')}</div>
        </div>
      </div>

      {showExportButton ? (
        <Button
          variant="success"
          disabled={!canExport || isExporting}
          onClick={onExport}
        >
          {isExporting ? (
            <Spinner animation="border" size="sm" />
          ) : (
            t('Export Report')
          )}
        </Button>
      ) : (
        <div className="text-right">
          <div className="font-weight-bold">{t('Reporting Period')}</div>
          <div className="text-muted small">{reportingPeriod}</div>
        </div>
      )}
    </div>
  );
};

export default BenchmarkHeader;
